module.exports = __webpack_public_path__ + "media/images/emblems/Niederhe-1eec47457e5aff90709c667ee969c63a.png";